import localizationKeys from "./localization-keys";

const ar = {
  // auth
  [localizationKeys.login]: "تسجيل الدخول",
  [localizationKeys.signup]: "إنشاء حساب جديد",
  [localizationKeys.loginWithApple]: "تسجيل الدخول باستخدام Apple",
  [localizationKeys.loginwithGoogle]: "تسجيل الدخول باستخدام Google",
  [localizationKeys.loginwithFacebook]: "تسجيل الدخول باستخدام Facebook",
  [localizationKeys.signupwithApple]: "تسجيل الدخول باستخدام Apple",
  [localizationKeys.signupwithGoogle]: "تسجيل الدخول باستخدام Google",
  [localizationKeys.signupwithFacebook]: "تسجيل الدخول باستخدام Facebook",
  [localizationKeys.somethingWentWrongPleaseTryAgainLater]:
    "هناك خطأ ما يرجى المحاولة مرة أخرى في او وقت لاحق",
  [localizationKeys.rememberPassword]: "تذكر كلمة المرور",
  [localizationKeys.forgetPassword]: "نسيت كلمة المرور",
  [localizationKeys.name]: "الاسم",
  [localizationKeys.email]: "البريد الإلكتروني",
  [localizationKeys.phone]: "الهاتف",
  [localizationKeys.password]: "كلمة المرور",
  [localizationKeys.iAgreetotheTermsConditions]: "أنا موافق على البنود والشروط",
  [localizationKeys.createAccount]: "إنشاء حساب",
  [localizationKeys.aVerificationMailHasBeenSent]:
    "تم إرسال بريد تحقق إلى بريدك ، يرجى التحقق منه ....",
  [localizationKeys.thePasswordHasBeenSuccessfullyChanged]:
    "تم تغيير كلمة المرور بنجاح",
  [localizationKeys.backToHome]: "العودة إلى الصفحة الرئيسية",
  [localizationKeys.resetPassword]: "إعادة تعيين كلمة المرور",
  [localizationKeys.newPassword]: "كلمة مرور جديدة",
  [localizationKeys.reEnterPassword]: "إعادة إدخال كلمة المرور",
  [localizationKeys.theEmailAddressForThisAccountHasNotYetBeenVerified]:
    "لم يتم التحقق من عنوان البريد الإلكتروني لهذا الحساب حتى الآن. يرجى التحقق من صندوق الوارد الخاص بك. إذا لم تتمكن من العثور على هذا البريد الإلكتروني",
  [localizationKeys.resendMailAgain]: "إعادة إرسال البريد مرة أخرى",
  [localizationKeys.or]: "أو",
  [localizationKeys.backToLogin]: "الرجوع إلى تسجيل الدخول",
  [localizationKeys.sentVerification]: "إرسال التحقق",
  // home
  [localizationKeys.myBids]: "مزاياداتي",
  [localizationKeys.categories]: "الفئات",
  [localizationKeys.watchlist]: "قائمة المراقبة",
  [localizationKeys.faqs]: "FAQs",
  [localizationKeys.support]: "الدعم",
  [localizationKeys.arabic]: "عربي",
  [localizationKeys.english]: "إنجليزي",
  [localizationKeys.sellNow]: "بيع الآن",
  [localizationKeys.search]: "بحث ...",
  [localizationKeys.registerNow]: "سجل الآن",
  [localizationKeys.profile]: "الملف الشخصي",
  [localizationKeys.viewDetails]: "عرض التفاصيل",
  [localizationKeys.bidNow]: "المزايدة الآن",
  [localizationKeys.popularCategories]: "الفئات الشائعة",
  [localizationKeys.results]: "من النتائج",
  [localizationKeys.seeAll]: "عرض الكل",
  [localizationKeys.brand]: "العلامة التجارية",
  [localizationKeys.sellingType]: "نوع البيع",
  [localizationKeys.auction]: "مزاد",
  [localizationKeys.buyNow]: "اشتري الآن",
  [localizationKeys.auctionState]: "حالة المزاد",
  [localizationKeys.comingSoon]: "قريباً",
  [localizationKeys.liveAuction]: "المزاد المباشر",
  [localizationKeys.location]: "الموقع",
  [localizationKeys.condition]: "الحالة",
  [localizationKeys.new]: "جديد",
  [localizationKeys.used]: "مستعملة",
  [localizationKeys.openBox]: "صندوق مفتوح",
  [localizationKeys.price]: "السعر",
  [localizationKeys.createAuctionNow]: "إنشاء مزاد الآن",
  [localizationKeys.weAreAlwaysHereToHelpYou]: "نحن دائمًا هنا لمساعدتك ...",
  [localizationKeys.subscribeNowToGetNewOffersAndUpdates]:
    "اشترك الآن للحصول على عروض وتحديثات جديدة",
  [localizationKeys.writeYourMail]: "اكتب بريدك ...",
  [localizationKeys.subscribe]: "اشتراك",
  [localizationKeys.sellingOnAllatre]: "البيع على Allatre",
  [localizationKeys.sellerCenter]: "مركز البائع",
  [localizationKeys.sellForCharity]: "بيع للجمعيات الخيرية",
  [localizationKeys.businessTools]: "أدوات العمل",
  [localizationKeys.createAuction]: "إنشاء مزاد",
  [localizationKeys.myAccount]: "حسابي",
  [localizationKeys.iamBiddingOn]: "أنا أقوم بالمزايدة على",
  [localizationKeys.iHaveBought]: "لقد اشتريت",
  [localizationKeys.bidsIHaveReceived]: "العطاءات التي استلمتها",
  [localizationKeys.iHaveSold]: "لقد بعت",
  [localizationKeys.allRightsReserved]: "جميع الحقوق محفوظة.",
  [localizationKeys.upComingAuctions]: "المزادات القادمة",
  [localizationKeys.totalBids]: "إجمالي المزادات",
  [localizationKeys.bid]: "مزاد",
  [localizationKeys.endingTime]: "نهاية الوقت",
  [localizationKeys.days]: "أيام",
  [localizationKeys.hrs]: "ساعة",
  [localizationKeys.min]: "دقيقة",
  // status
  [localizationKeys.activeNow]: "نشط الآن",
  [localizationKeys.Scheduled]: "  مجدولة",
  [localizationKeys.sold]: "مباع",
  [localizationKeys.pending]: "معلق",
  [localizationKeys.expired]: "منتهي",
  [localizationKeys.cancelled]: "تم الغاء",
  [localizationKeys.blocked]: "مسدود",
  // Breadcrumb
  [localizationKeys.home]: "الصفحة الرئيسية",
  [localizationKeys.productDetails]: "تفاصيل المنتج",
  [localizationKeys.auctionDetails]: "تفاصيل المزاد",
  [localizationKeys.shippingDetails]: "تفاصيل الشحن",
  [localizationKeys.paymentDetails]: "تفاصيل الدفع",
  [localizationKeys.myAuctions]: "مزاداتي",
  [localizationKeys.activeAuctions]: "المزادات النشطة",
  [localizationKeys.scheduledAuctions]: "المزادات المجدولة",
  [localizationKeys.soldAuctions]: "المزادات المباعة",
  [localizationKeys.pendingAuctions]: "المزادات المعلقة",
  [localizationKeys.expiredAuctions]: "المزادات المنتهية",
  // create auctions
  [localizationKeys.drafts]: "المسودات",
  [localizationKeys.proceed]: "متابعة",
  [localizationKeys.successDelete]: "تم حذف مزادك من صياغتك بنجاح",
  [localizationKeys.errorDelete]:
    "عفوًا ، آسف لحدوث خطأ ما ، يرجى التأكد من صحة كل شيء والمحاولة مرة أخرى",
  [localizationKeys.areYouSureYouWantToDeleteThisDraft]:
    "هل أنت متأكد أنك تريد حذف هذه المسودة",
  [localizationKeys.cancel]: "إلغاء",
  [localizationKeys.yesDelete]: "نعم ، احذف",
  [localizationKeys.locationIsRequired]: "الموقع مطلوب",
  [localizationKeys.inOrderToFinishTheProcedureWeHaveToGetAccessTo]:
    "من أجل إنهاء الإجراء ، علينا الوصول إلى",
  [localizationKeys.yourLocationYouCanManageThemLater]:
    "موقعك. يمكنك إدارتها لاحقًا.",
  [localizationKeys.manageYouAddresses]: "إدارة عناوينك",
  [localizationKeys.country]: "دولة",
  [localizationKeys.city]: "المدينة",
  [localizationKeys.address]: "العنوان",
  [localizationKeys.addressLabel]: "علامة للعنوان",
  [localizationKeys.zipCode]: "الرمز البريدي",
  [localizationKeys.successAddLocatons]: "إضافة موقع النجاح",
  [localizationKeys.add]: "إضافة",
  [localizationKeys.selectCountry]: "تحديد البلد",
  [localizationKeys.selectCity]: "اختر المدينة",
  [localizationKeys.wirteYourAddress]: "اكتب عنوانك",
  [localizationKeys.exHome]: "مثال:  المنزل",
  [localizationKeys.enterPostalZipCode]: "أدخل الرمز البريدي",
  // product details
  [localizationKeys.itemDetails]: "تفاصيل العنصر",
  [localizationKeys.itemName]: "اسم العنصر",
  [localizationKeys.category]: "الفئة",
  [localizationKeys.subCategory]: "فئة فرعية",
  [localizationKeys.itemDescription]: "وصف العنصر",
  [localizationKeys.writeItemDescription]: "اكتب وصف العنصر ....",
  [localizationKeys.addMedia]: "إضافة وسائط",
  [localizationKeys.from3upto5photos]: "( من 3 إلى 5 صور )",
  [localizationKeys.itemCondition]: "حالة العنصر",
  [localizationKeys.saveAsDraft]: "حفظ كمسودة",
  [localizationKeys.next]: "التالي",
  // auction details
  [localizationKeys.quickAuction]: "المزاد السريع",
  [localizationKeys.maximumDurationMustBeDay]:
    "يجب أن تكون المدة القصوى باليوم",
  [localizationKeys.longAuction]: "المزاد الطويل",
  [localizationKeys.durationMoreThanOneDayFromStartingDate]:
    "المدة أكثر من يوم واحد من تاريخ البدء",
  [localizationKeys.longAuction]: "المزاد الطويل",
  [localizationKeys.Hrs]: "ساعات.",
  [localizationKeys.auctionDuration]: "مدة المزاد",
  [localizationKeys.scheduleBid]: "مزاد مجدول",
  [localizationKeys.optional]: "(اختياري)",
  [localizationKeys.unlessStartTimeAndDateAreChosenYourListingBecomesActiveImmediately]:
    "ما لم يتم اختيار وقت وتاريخ البدء ، تصبح قائمتك نشطة على الفور.",
  [localizationKeys.startDate]: "تاريخ البدء",
  [localizationKeys.time]: "الوقت",
  [localizationKeys.pricing]: "التسعير",
  [localizationKeys.minimumPrice]: "سعر الحد الأدنى",
  [localizationKeys.purchasingPrice]: "سعر الشراء",
  [localizationKeys.minimum30MoreThanStartingBid]:
    "الحد الأدنى: 30٪ أكثر من عرض السعر المبدئي",
  [localizationKeys.purchasingPriceMustBeMoreThanOrEqual30OfMinimumPrice]:
    "يجب أن يكون سعر الشراء أكبر من أو يساوي 30٪ من الحد الأدنى للسعر",
  // shiping details
  [localizationKeys.locationDetails]: "تفاصيل الشحن",
  [localizationKeys.addAddress]: "إضافة عنوان",
  // profile
  [localizationKeys.online]: "متصل",
  [localizationKeys.logout]: "تسجيل الخروج",
  [localizationKeys.profileSettings]: "إعدادات الملف الشخصي",
  [localizationKeys.completeYourProfileToMakeYourActionsEasier]:
    "أكمل ملفك الشخصي لتسهيل إجراءاتك",
  [localizationKeys.completeNowMasg]:
    "يوفر حسابك حاليًا إمكانية الوصول إلى التحديثات والعناصر المحفوظة وتفاصيل البيع والميزات الأخرى. للمزايدة والشراء والبيع باستخدام Alle-tre ، يرجى قضاء بعض الوقت لملء معلومات ملفك الشخصي.",
  [localizationKeys.completeNow]: "أكمل الآن",
  [localizationKeys.editPhoto]: "تحرير الصورة",
  [localizationKeys.uploadPhoto]: "تحميل الصورة",
  [localizationKeys.dropYourPhotoHereToInstantlyUploadIt]:
    "أفلت صورتك هنا لتحميلها على الفور",
  [localizationKeys.save]: "حفظ",
  [localizationKeys.selectAfile]: "حدد ملفًا",
  [localizationKeys.edit]: "تحرير",
  [localizationKeys.editUserName]: "تحرير اسم المستخدم",
  [localizationKeys.personalDetails]: "التفاصيل الشخصية",
  [localizationKeys.userName]: "اسم المستخدم",
  [localizationKeys.changePassword]: "تغيير كلمة المرور",
  [localizationKeys.editPassword]: "تحرير كلمة المرور",
  [localizationKeys.oldPassword]: "كلمة المرور القديمة",
  [localizationKeys.newPassword]: "كلمة المرور الجديدة",
  [localizationKeys.verified]: "تم التحقق منه",
  [localizationKeys.eMail]: "البريد الإلكتروني",
  [localizationKeys.phoneNumber]: "رقم الهاتف",
  [localizationKeys.editPhoneNumber]: "تحرير رقم الهاتف",
  [localizationKeys.loginService]: "خدمة تسجيل الدخول",
  [localizationKeys.loginServiceMaseg]:
    "حساب Alla-tre الخاص بك ليس لديه خدمة تسجيل دخول خارجية. قم بتوصيل الحسابات الآن للوصول السريع والآمن",
  [localizationKeys.connected]: "متصل",
  [localizationKeys.connectedWithApple]: "متصل مع Apple",
  [localizationKeys.connectWithGoogle]: "متصل مع Google",
  [localizationKeys.connectWithFacebook]: "متصل مع Facebook",
  [localizationKeys.addressBook]: "دفتر العناوين",
  [localizationKeys.addressBookmasg]:
    "إدارة عناوينك للحصول على تجربة دفع سريعة وسهلة",
  [localizationKeys.default]: "افتراضي",
  [localizationKeys.delete]: "حذف",
  [localizationKeys.makeDefault]: "جعله افتراضيًا",
  [localizationKeys.the]: " ال",
  [localizationKeys.yourWatchlist]: "قائمة المراقبة الخاصة بك",
  [localizationKeys.thereAreNoWatchlistYet]: "لا توجد قائمة المراقبة حتى الآن.",
  // myauctions
  [localizationKeys.createNow]: "أنشئ الآن",
  [localizationKeys.thereAreNoAuctionsCurrentlyMakeYourFirstAuctionRightAway]:
    "لا توجد مزادات حاليًا. قم بإجراء مزادك الأول على الفور.",
  [localizationKeys.totalAuctions]: "إجمالي المزادات",
  [localizationKeys.active]: "نشط",
  [localizationKeys.total]: "إجمالي",
  [localizationKeys.totalActive]: "إجمالي المزادات النشطة ..",
  [localizationKeys.youCanCreateOne]: "يمكنك إنشاء واحد",
  [localizationKeys.oppsActive]: "عفوًا ، لا توجد مزادات نشطة حتى الآن.",
  [localizationKeys.lastPrice]: "آخر سعر",
  [localizationKeys.startingPrice]: "السعر المبدئي",
  [localizationKeys.startingDate]: "تاريخ البدء",
  [localizationKeys.pendingDeposit]: "إيداع معلق",
  [localizationKeys.purchasePrice]: " سعر الشراء",
  [localizationKeys.endingDate]: " تاريخ الانتهاء",
  [localizationKeys.endingTime]: " وقت الانتهاء",
  [localizationKeys.totalScheduled]: "إجمالي المزادات المجدولة ..",
  [localizationKeys.opsScheduled]: "عفوًا ، لا توجد مزادات مجدولة بعد",
  [localizationKeys.totalDraft]: "إجمالي مزادات المسودة ..",
  [localizationKeys.opsDraft]: "عفوًا ، لا توجد مزادات منتهية الصلاحية بعد.",
  [localizationKeys.totalSold]: "إجمالي المزادات المباعة ..",
  [localizationKeys.opsSold]: "عفوًا ، لا توجد مزادات مباعة بعد.",
  [localizationKeys.totalPending]: "إجمالي المزادات المعلقة ..",
  [localizationKeys.opsPending]: "عفوًا ، لا توجد عمليات بيع معلقة حتى الآن.",
  [localizationKeys.totalExpired]: "إجمالي المزادات المنتهية الصلاحية ...",
  [localizationKeys.totalCancelled]: "إجمالي المزادات الملغاة...",
  // details
  [localizationKeys.reviews]: "مراجعات",
  [localizationKeys.timeLeft]: "الوقت المتبقي",
  [localizationKeys.submitBid]: "إرسال مزايدتك",
  [localizationKeys.description]: "الوصف",
  [localizationKeys.series]: "رقم تسلسلي",
  [localizationKeys.bidderName]: "اسم المزايد",
  [localizationKeys.biddingEndingTime]: "وقت انتهاء المزايدة",
  [localizationKeys.lastBidAmount]: "مبلغ المزايدة الأخير",
  [localizationKeys.totalBidders]: "إجمالي المزايدين",
  [localizationKeys.biddingTime]: "وقت  المزايدين",
  [localizationKeys.bidAmount]: "مبلغ المزايدة",
  [localizationKeys.startingBidAmount]: "بدء مبلغ المزايدة",
  [localizationKeys.currentBid]: " المزايدة الحالية",
  [localizationKeys.submitValueIsRequiredAndMustBeBiggerThanCurrentBid]:
    "إرسال القيمة مطلوبة ويجب أن تكون أكبر من المزايدة الحالي",
  [localizationKeys.yourAddNewSubmitValueSuccessfully]:
    "إضافة قيمة إرسال جديدة بنجاح",
  [localizationKeys.congratulationsOnYourFirstBid]: "مبروك على عرضك الأول",
  [localizationKeys.editBid]: "تحرير المزايدة",
  [localizationKeys.pay]: "الدفع",
  [localizationKeys.deposit]: "إيداع",
  [localizationKeys.YouAreAboutToPlaceBidFor]: "أنت على وشك تقديم مزايدة",
  [localizationKeys.InThisAuctionPleaseNoticeThatYouWillNeedToPayA]:
    "في هذا المزاد ، يرجى ملاحظة أنك ستحتاج إلى دفع أ",
  [localizationKeys.ofThePriceAsADepositOnlyOnceSoYouCanFreelyEnjoyBidding]:
    "من السعر كوديعة مرة واحدة فقط حتى تتمكن من الاستمتاع بالمزايدة بحرية",
  [localizationKeys.endingPrice]: "السعر النهائي",
  [localizationKeys.viewAll]: "عرض الكل",
  // tab details
  [localizationKeys.shippingPolicy]: "سياسة الشحن",
  [localizationKeys.returnPolicy]: " سياسة الإرجاع",
  [localizationKeys.payment]: "الدفع",
  [localizationKeys.feedback]: "الملاحظات",
  [localizationKeys.aboutTheBrand]: "حول العلامة التجارية",
  // err
  [localizationKeys.required]: "مطلوب",
  [localizationKeys.makeSureThatYouChooseItemConditionValue]:
    "تأكد من اختيار قيمة حالة العنصر",
  [localizationKeys.makeSureThatYouChooseAtLeastThreeOrMorePhotos]:
    "تأكد من اختيار ثلاث صور على الأقل أو أكثر",
  [localizationKeys.oops]:
    "عفوًا ، آسف لحدوث خطأ ما ، يرجى التأكد من صحة كل شيء والمحاولة مرة أخرى",
  // sucsess
  [localizationKeys.thisAuctionDeleteFromWatchListBeenSuccessfully]:
    "تم حذف هذا المزاد من قائمة المراقبة بنجاح",
  [localizationKeys.thisAuctionAddToWatchListBeenSuccessfully]:
    "تم إضافة هذا المزاد إلى قائمة المراقبة بنجاح",
  [localizationKeys.thePasswordHasBeenEditSuccessfully]:
    "تم تحديث كلمة المرور بنجاح",
  [localizationKeys.hasBeenDeleteSuccessfully]: "تم حذفه بنجاح",
  [localizationKeys.hasBeenMakeDefaultSuccessfully]: "تم جعله افتراضيًا بنجاح",
  [localizationKeys.uploadImageHasbeenSuccessfully]: "تم تحميل الصورة بنجاح",
  [localizationKeys.nameHasBeenEditSuccessfully]: "تم تحرير الاسم بنجاح",
  [localizationKeys.yourAuctionSaveAsDraftedSuccess]: "مزادك حفظ كمسودة نجاح",
  [localizationKeys.yourAuctionIsCreatedSuccess]: "تم إنشاء مزادك بنجاح",
  [localizationKeys.makeSureThatYouChooseTheAuctionLocationOrCreateAnotherOne]:
    "تأكد من اختيار موقع المزاد أو إنشاء موقع آخر",
  //messages
  [localizationKeys.YouSuccessfullyCancelledTheAuction]:
    "تم إلغاء المزاد بنجاح..!",
  //wallet
  [localizationKeys.WalletBalance]: "رصيد المحفظة",
  [localizationKeys.AccountBalance]: "رصيد الحساب",
  [localizationKeys.Withdraw]: "ينسحب",
  [localizationKeys.Date]: "تاريخ",
  [localizationKeys.Withdrawals]: "السحوبات",
  [localizationKeys.Balance]: "توازن",
  [localizationKeys.Description]: "وصف",
  [localizationKeys.adminObjections]: "إدارة الاعتراضات",
  [localizationKeys.product]: "المنتج",
  [localizationKeys.noResultsFound]: "لم يتم العثور على نتائج",
  [localizationKeys.objectionBy]: "تم الاعتراض بواسطة",
  [localizationKeys.repliedBy]: "تم الرد بواسطة",
  [localizationKeys.repliedOn]: "تم الرد في",
  [localizationKeys.reason]: "السبب",
  [localizationKeys.documents]: "المستندات",
  [localizationKeys.status]: "الحالة",
  [localizationKeys.date]: "التاريخ",
  [localizationKeys.actions]: "الإجراءات",
  [localizationKeys.noFiles]: "لا توجد ملفات",
  [localizationKeys.inProgress]: "قيد التنفيذ",
  [localizationKeys.solved]: "تم الحل",
  [localizationKeys.userComplaints]: "شكاوى المستخدمين",
  [localizationKeys.complainingUser]: "المستخدم المشتكي",
  [localizationKeys.seller]: "البائع",
  [localizationKeys.complaint]: "الشكوى",
  [localizationKeys.complaintStatus]: "حالة الشكوى",
  [localizationKeys.actionStatus]: "حالة الإجراء",
  [localizationKeys.complaintDetails]: "تفاصيل الشكوى",
  [localizationKeys.sellerDetails]: "تفاصيل البائع",
  [localizationKeys.winnerDetails]: "تفاصيل الفائز",
  [localizationKeys.mediaGalleryOfComplaints]: "معرض وسائط الشكاوى",
  [localizationKeys.noMediaAvailable]: "لا توجد وسائط متاحة",
  [localizationKeys.close]: "إغلاق",
  [localizationKeys.reply]: "الرد",
  [localizationKeys.finalDecision]: "القرار النهائي",
  [localizationKeys.submitFinalDecision]: "تقديم القرار النهائي",
  [localizationKeys.adminFinalDecision]: "القرار النهائي للإدارة",
  [localizationKeys.finalDecisionFiles]: "مستندات القرار النهائي",
  [localizationKeys.noFinalDecision]: "لم يتم تقديم قرار نهائي بعد.",
  [localizationKeys.finalDecisionSubmitted]: "تم تقديم القرار النهائي بنجاح.",
};

export default ar;
